import { logger } from "../../../utils/logger";
import React, { memo, useEffect, useState } from "react";

import { ActionHistoryProps, DocumentsObjectType } from "../types";
import { COLORS } from "../constants";

import API, { getFullURL } from "../../../hooks/api";
import { MANUAL_SALARY_DOCUMENT_VIEW } from "../../../utils/Endpoints";

import "../styles.css";

interface ExtendedActionHistoryProps extends ActionHistoryProps {
  viewDocumentInfo: DocumentsObjectType;
  financialId: number | "";
}

const DocumentView: React.FC<ExtendedActionHistoryProps> = ({
  close,
  viewDocumentInfo,
  financialId,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);




  const handleDownload = () => {
    if (!pdfUrl) return;
  
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = viewDocumentInfo.title; // filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  useEffect(() => {
    //Lock background scroll
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const fetchPdf = async () => {
      try {
        const res = await API.get(getFullURL(MANUAL_SALARY_DOCUMENT_VIEW), {
          params: {
            id: financialId,
            docType: viewDocumentInfo.docType,
          },
          responseType: "blob",
        });

        if (!res?.data) {
          logger.error("PDF data is missing");
          close(); // nothing to show, and the X button only renders once a PDF is loaded
          return;
        }

        const blob = new Blob([res.data], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch (error) {
        logger.error("Failed to load PDF", error);
        close();
      }
    };

    fetchPdf();

    return () => {
      //Restore background scroll
      document.body.style.overflow = originalOverflow;
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [financialId, viewDocumentInfo.docType]);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center"
      style={{
        background: "rgba(0,0,0,0.4)",
        zIndex: 9999,
        padding: "40px 0", // space from top & bottom (IMPORTANT)
      }}
    >
      {pdfUrl && (
        <div
          className="pdf-modal-content d-flex flex-column bg-white p-3 rounded shadow"
          style={{
            width: "90%",
            maxWidth: "900px",
            height: "100%"
          }}
        >
          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 style={{ color: COLORS.TEXT_PRIMARY }}>{""}</h5>
            <button className="btn p-2" onClick={close}>
              <i className="bi bi-x-lg" />
            </button>
          </div>

          {/* PDF VIEWER AREA */}
          <div
            style={{
              flex: 1,
              minHeight: 0,
              width: "100%",
              background: "white",
            }}
          >
            {pdfUrl && (
              <iframe
                src={pdfUrl}
                title="Document"
                style={{ width: "100%", height: "100%", border: 0 }}
              />
            )}
          </div>

          {/* FOOTER */}
          <div className="d-flex border-top align-items-center justify-content-center w-100 pt-3">
            <button
              type="button"
              className="btn border d-flex align-items-center gap-2 px-4 py-2"
              onClick={handleDownload}
              style={{ fontWeight: 500 }}
            >
              <i className="bi bi-cloud-download" />
              <span>Download PDF</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(DocumentView);
